export function uniqueBy<T>(array: T[], property: keyof T): T[] {
  const seen = new Set();

  return array.filter((item) => {
    const value = item[property];
    if (seen.has(value)) {
      return false;
    }
    seen.add(value);
    return true;
  });
}
